module.exports = __webpack_public_path__ + "static/media/logLiquidRemaining.d39c5693.svg";